// Lógica pura extraída de apiFolders.js — validação/payload sem depender de
// `con`/store, para ser testada diretamente (ver CLAUDE.md "vue-jest
// Limitation" e o padrão do resto do projeto: arquivos de API não ganham
// .unit.js mockando conexão; a lógica testável vira util puro).

export function cleanRequiredName(name) {
  const clean = (name || '').trim()
  return clean || null
}

export function sanitizeReorderList(orders) {
  return Array.isArray(orders) ? orders.filter((o) => o && o.id) : []
}

export function isFolderCacheFresh(lastUpdate, ttlMs) {
  return !!lastUpdate && Date.now() - lastUpdate < ttlMs
}

// Cor e escolha livre do usuario (v-color-picker) — so valida o formato hex,
// nao contra uma paleta fixa (o backend faz a mesma validacao solta).
const HEX_COLOR_REGEX = /^#[0-9A-Fa-f]{6}$/

export function isValidHexColor(color) {
  return typeof color === 'string' && HEX_COLOR_REGEX.test(color)
}

// Sugestao inicial de cor pro modal de criar pasta — so um chute aleatorio
// pra pre-popular o picker; o usuario pode trocar livremente antes de salvar.
export function randomPaletteColor(paleta) {
  if (!Array.isArray(paleta) || !paleta.length) return null
  const index = Math.floor(Math.random() * paleta.length)
  return paleta[index]
}
